import { DialogActions, DialogContent } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
import { Modal } from '../../../../../../ui/components/pure/modal/modal.component';
import { TextButton } from '../../../../../../ui/components/pure/text-button/text-button.component';

export function OpenLockerNotPermitted({ onClose }: { onClose(): void }) {
  return (
    <Modal title={'Open locker?'} loading={false} open={true} maxWidth="xs" onClose={onClose}>
      <DialogContent>
        <Alert style={{ marginBottom: '8px' }} variant="outlined" severity="error">
          <AlertTitle>Not permitted</AlertTitle>
          This locker cannot be opened by you right now, as you don't own the last delivery made to it. Please reach out
          to our customer support team if you require assistance.
        </Alert>
      </DialogContent>
      <DialogActions>
        <TextButton color="secondary" variant="outlined" onClick={onClose}>
          Close
        </TextButton>
      </DialogActions>
    </Modal>
  );
}
